import api, { prepareQueryParameters } from "@/store/api";
import {
	Params
} from "@/types";

interface AssetParams extends Params {
	investmentStrategyId: number;
	from?: Date;
	to?: Date;
}

const emptyState = () => {
	return {
		equities: [],
		availableStrategies: [],
		sellStrategies: [],
		withdrawalStrategies: [],
		banks: [],
		sfaInstruction: {},
	}
};

const state = emptyState();
type State = typeof state;

export default {
	namespaced: true,
	state: emptyState(),
	getters: {
		getSfaInstruction: (state: State) => {
			return state.sfaInstruction;
		},
	},
	actions: {
		availableStrategies(store: any) {
			api
				.get("frontend-instructions/available-strategies")
				.then(({data}) => {
					store.commit("setAvailableStrategies", data.result);
				})
				.catch((error) => {
					store.commit("setAvailableStrategies", []);
				});
		},
		sellStrategies(store: any) {
			api
				.get("frontend-instructions/sell-strategies")
				.then(({data}) => {
					store.commit("setSellStrategies", data.result);
				})
				.catch((error) => {
					store.commit("setSellStrategies", []);
				});
		},
		withdrawalStrategies(store: any) {
			api
				.get("frontend-instructions/withdrawal-strategies")
				.then(({data}) => {
					store.commit("setWithdrawalStrategies", data.result);
				})
				.catch((error) => {
					store.commit("setWithdrawalStrategies", []);
				});
		},
		equities(store: any, params: AssetParams) {
			api
				.get(`frontend-instructions/equities?${prepareQueryParameters(params)}`)
				.then(({ data }) => {
					store.commit("setEquities", data.result);
				})
				.catch((error) => {
					//
				});
		},
		banks(store: any) {
			api
				.get("frontend-instructions/banks")
				.then(({data}) => {
					store.commit("setBanks", data.result);
				})
				.catch((error) => {
					store.commit("setBanks", []);
				});
		},
		depositOrWithdrawal(store: any, params: any) {
			return new Promise((resolve, reject) => {
				api.post('frontend-instructions/deposit-or-withdrawal', params).then((response) => {
					store.dispatch('messages/status', '', { root: true });
					resolve(response.data);
				}).catch((error) => {
					if (!error.response.data.result.accountStatus) {
						store.dispatch("alert/warning", error.response.data.result, { root: true });
					}
					reject(error);
				});
			});
		},
		depositOrWithdrawalSFA(store: any, params: any) {
			return new Promise((resolve, reject) => {
				api.post('frontend-instructions/deposit-or-withdrawal-sfa', params).then((response) => {
					store.dispatch('messages/status', '', { root: true });
					resolve(response.data);
				}).catch((error) => {
					if (!error.response.data.result.accountStatus) {
						store.dispatch("alert/warning", error.response.data.result, { root: true });
					}
					reject(error);
				});
			});
		},
		equityInstruction(store: any, params: any) {
			return new Promise((resolve, reject) => {
				api.post('frontend-instructions/equityInstruction', params).then(() => {
					store.dispatch('messages/status', '', { root: true });
					resolve();
				}).catch((error) => {
					if (!error.response.data.result.accountStatus) {
						store.dispatch("alert/warning", error.response.data.result, { root: true });
					}
					reject(error);
				});
			});
		},
		equityInstructionSFA(store: any, params: any) {
			return new Promise((resolve, reject) => {
				api.post('frontend-instructions/equityInstructionSfa', params).then(() => {
					store.dispatch('messages/status', '', { root: true });
					resolve();
				}).catch((error) => {
					if (!error.response.data.result.accountStatus) {
						store.dispatch("alert/warning", error.response.data.result, { root: true });
					}
					reject(error);
				});
			});
		},
	},
	mutations: {
		setEquities(state: State, data: any) {
			state.equities = data;
		},
		setAvailableStrategies(state: State, data: any) {
			state.availableStrategies = data;
		},
		setSellStrategies(state: State, data: any) {
			state.sellStrategies = data;
		},
		setWithdrawalStrategies(state: State, data: any) {
			state.withdrawalStrategies = data;
		},
		setBanks(state: State, data: any) {
			state.banks = data;
		},
		setSfaInstruction(state: State, data: any) {
			state.sfaInstruction = data;
		},
	},
};
